var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentCenter-footer"},[_vm._v(" JDH健康内容开放平台 Copyright @ 2020-2021 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }